// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"484e66f7","239":"d709620d","453":"8416de6a","455":"a3d15d3d","884":"0aadee66"}[chunkId] + ".chunk.js";
};